import type { TOC } from '@ember/component/template-only';
import {
  PrismButton,
  PrismLoadingBar,
  PrismMessage,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralDatepickersDatepickerDisabled from 'lumen/components/general/datepickers/datepicker-disabled';
import GeneralPageHeader from 'lumen/components/general/page/header';
import GeneralPageMain from 'lumen/components/general/page/main';
import HotelAndMarketDropdownsAccountSelectorWrapper from 'lumen/components/hotel-and-market/dropdowns/account-selector-wrapper';
import ParityButtonGroup from 'lumen/components/parity/button-group';
import ParityTablesTableParityPos from 'lumen/components/parity/tables/table-parity-pos';
import type HotelParityPosController from 'lumen/controllers/hotel/parity/pos';

interface HotelParityPosSignature {
  Args: {
    controller: HotelParityPosController;
    model: unknown;
  };
}

<template>
  <GeneralPageHeader>
    <div class="content-wrapper">
      <div class="flex justify-between">
        <div class="flex gap-400">
          <HotelAndMarketDropdownsAccountSelectorWrapper @hasDivider={{true}} />
          <GeneralDatepickersDatepickerDisabled
            @placeholder={{t "general.next_days" count=30}}
          />
        </div>
        <div class="rates-navbar">
          <div class="ota-selections-container rates-navbar-scroller">
            <div class="select-wrapper">
              <div class="no-filter-content">
                {{t "rates.lowest"}}
              </div>
            </div>
            <div class="select-wrapper">
              <div class="no-filter-content">
                {{t "rates.nights" count=@controller.los}}
              </div>
            </div>
            <div class="select-wrapper">
              <div class="no-filter-content">
                {{t "rates.persons_selection" count=@controller.maxPersons}}
              </div>
            </div>
            <div class="select-wrapper">
              <div class="no-filter-content">
                {{t "rates.meal.any"}}
              </div>
            </div>
          </div>
        </div>

        <div class="flex items-center justify-center gap-200">
          <ParityButtonGroup />
          <PrismButton
            @buttonType="secondary"
            @iconBefore="export"
            @label={{t "general.export"}}
            @onClick={{@controller.handleExport}}
            data-event-id="export-button"
          />
        </div>
      </div>
    </div>
  </GeneralPageHeader>

  <GeneralPageMain>
    <div class="content-wrapper main-content--new-layout h-full">
      {{#if @controller.model.isLoading}}
        <PrismLoadingBar @isFixed={{true}} @positionTop={{120}} />
      {{/if}}
      {{#if @controller.isPosAvailable}}
        <ParityTablesTableParityPos
          {{! @glint-expect-error: Incorrect type }}
          @availableOTAs={{@controller.availableOTAs}}
          @isLoading={{@controller.model.isLoading}}
          @model={{@controller.model.periods}}
        />
      {{else}}
        <div class="flex flex-row items-center justify-center">
          <PrismMessage
            @description={{t "rates.disconnected_ota"}}
            @illustration="100x100_critical"
            @title={{t "rates.disconnected_ota_title"}}
          />
        </div>
      {{/if}}
    </div>
  </GeneralPageMain>
</template> satisfies TOC<HotelParityPosSignature>;
